import ModalManager from '@material-ui/core/Modal/ModalManager';

const modalManager = new ModalManager();

export { modalManager };